import { STORAGE_KEY } from '/@/constants/storage';

export const setLocalTeamId = (id: string) => {
  window.localStorage.setItem(STORAGE_KEY.localTeamId, id);
};

export const getLocalTeamId = (): string => {
  return window.localStorage.getItem(STORAGE_KEY.localTeamId) ?? '';
};
